export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  editarTipoUsuario: {
    pt: 'Editar Tipo de Usuário',
    en: 'Edit User Type',
    de: 'Benutzertyp bearbeiten',
    es: 'Editar tipo de usuario',
  },
  nome: {
    pt: 'Nome',
    en: 'Name',
    de: 'Name',
    es: 'Nombre',
  },
  modulo: {
    pt: 'Módulo',
    en: 'Module',
    de: 'Modul',
    es: 'Módulo',
  },
  configuracoesTipo: {
    pt: 'Configurações do tipo de usuário',
    en: 'User type settings',
    de: 'Benutzertyp-Einstellungen',
    es: 'Configuraciones del tipo de usuario',
  },
  configuracoesTabela: {
    pt: 'Configurações de listagem',
    en: 'Listing settings',
    de: 'Listeneinstellungen',
    es: 'Configuraciones de listado',
  },
  configuracoesFiltro: {
    pt: 'Configurações de filtro',
    en: 'Filter settings',
    de: 'Filtereinstellungen',
    es: 'Configuraciones de filtro',
  },
  configuracoesRelatorio: {
    pt: 'Configurações de relatório',
    en: 'Report settings',
    de: 'Berichtseinstellungen',
    es: 'Configuraciones de informe',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Geh zurück',
    es: 'Regresa',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'kündiger',
    es: 'Cancelar',
  },
  salvar: {
    pt: 'Salvar',
    en: 'Save',
    de: 'Speichern',
    es: 'Salvar',
  },
};
